// Bus events between the reply box, the schedule dialog and the scheduled-messages bar
export const SCHEDULE_EVENTS = {
  CHANGED: 'LOCO_SCHEDULED_MESSAGES_CHANGED',
  // The reply box clears its draft when it was scheduled (see ReplyBox.vue)
  REPLY_SCHEDULED: 'LOCO_REPLY_SCHEDULED',
};

export const browserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

const pad = value => String(value).padStart(2, '0');

export const toDateInput = date =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const toTimeInput = date =>
  `${pad(date.getHours())}:${pad(date.getMinutes())}`;

// Local date ("2026-10-23") + time ("09:00") in the browser's zone → Date
export const fromInputs = (date, time) => new Date(`${date}T${time}:00`);

// Quick picks: in one hour, tomorrow 9:00, next Monday 9:00
export const quickTimes = (now = new Date()) => {
  const inAnHour = new Date(now.getTime() + 60 * 60 * 1000);
  inAnHour.setSeconds(0, 0);

  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  tomorrow.setHours(9, 0, 0, 0);

  const monday = new Date(now);
  monday.setDate(now.getDate() + ((8 - now.getDay()) % 7 || 7));
  monday.setHours(9, 0, 0, 0);

  return { inAnHour, tomorrow, monday };
};

export const formatWhen = (timestamp, locale) =>
  new Date(timestamp * 1000).toLocaleString(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
